export var mfOrderBookMapper = function (data) {
    var result = [];
    if (data && data.length > 0 && typeof data !== "string") {
        result = data.map(function (item) {
            return {
                acCode: item.acCode,
                tradeDate: item.tradeDate,
                schemeName: item.schemeName,
                buySell: item.buySell,
                price: item.price,
                nav: item.nav,
                unit: item.unit,
                remarks: item.remarks,
                exchangeStatus: item.exchangeStatus,
                exchange: item.exchange,
            };
        });
    }
    return result;
};
